<template>
  <v-layout row wrap>
    <Stock v-for="stk in stocks" :key="stk.id" :stock="stk"/>
  </v-layout>
</template>

<script>
import Stock from './Stock'

export default {
  components: { Stock },
  computed: {
    stocks() {
      return this.$store.getters.stocks
    }
  }
}
</script>

<style>

</style>

